import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import BulletTypography from '@/common/components/base/typography/BulletTypography';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { useFileStatisticsModalQueryOptions } from '@/modules/Dashboard/queries/fileStatisticsModalQuery/fileStatisticsModalQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { css } from 'styled-system/css';
import { Box, Center, Flex } from 'styled-system/jsx';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal closeModal={closeModal} open={open}>
    <FileStatisticsCardModal />
  </MainModal>
);

const FileStatisticsCardModal = () => {
  const {
    data: fileStatisticsModalData,
    isPending: isFileStatisticsModalDataPending,
    isError: isFileStatisticsModalDataError,
  } = useQuery(useFileStatisticsModalQueryOptions);

  if (isFileStatisticsModalDataError) {
    return <></>;
  }
  if (isFileStatisticsModalDataPending) {
    return (
      <Center height="311px">
        <CircularLoading color="colors.purple-primary" />
      </Center>
    );
  }
  return (
    <>
      <Box pb="24px">
        <TitleDescription textStyle="h2">آمار ماه گذشته</TitleDescription>
      </Box>
      <Box
        width="100%"
        mb="1.5rem"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Typography textStyle="h2">کل پرونده‌ها </Typography>
        <Typography textStyle="h2">{fileStatisticsModalData?.total}</Typography>
      </Box>
      <Box
        mx="auto"
        maxHeight="60vh"
        height="100%"
        overflow="auto"
        display="flex"
        flexDirection="column"
        gap="12px"
        scrollbar={'hidden'}
      >
        {fileStatisticsModalData?.items.map((item) => (
          <Flex
            justifyContent="space-between"
            key={item.name}
            alignItems="center"
            pb="12px"
            borderBottom="1px solid  {colors.gray-3}"
            _last={{
              borderBottom: 'none',
            }}
          >
            <BulletTypography
              backgroundColor="purple-3"
              className={css({
                height: '10px',
                width: '10px',
              })}
            >
              {item.fa_name}
            </BulletTypography>
            <CustomLabel color="grey" title={`${item.count.toString()} مورد`} />
          </Flex>
        ))}
      </Box>
    </>
  );
};
